var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKorrosionsschutzVerhindertKaltschweissen = function SvgKorrosionsschutzVerhindertKaltschweissen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Korrosionsschutz_verhindert_Kaltschweissen_svg__Ebene_2",
    viewBox: "0 0 116.89 94.76"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Korrosionsschutz_verhindert_Kaltschweissen_svg__cls-2{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
    id: "Korrosionsschutz_verhindert_Kaltschweissen_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.44 23.63c-19.2 0-34.81 15.62-34.81 34.82s15.62 34.81 34.81 34.81 34.81-15.62 34.81-34.81-15.62-34.82-34.81-34.82Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.44 11.77c-25.72 0-46.65 20.91-46.68 46.62h3.09c.04-24 19.58-43.52 43.59-43.52s43.55 19.52 43.59 43.52h3.09c-.04-25.71-20.96-46.62-46.68-46.62",
    className: "Korrosionsschutz_verhindert_Kaltschweissen_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.44 0C26.24 0 .04 26.18 0 58.38h3.09C3.13 27.89 27.94 3.09 58.44 3.09s55.32 24.79 55.35 55.29h3.09C116.84 26.18 90.64 0 58.44 0",
    className: "Korrosionsschutz_verhindert_Kaltschweissen_svg__cls-2"
  }))));
};
export default SvgKorrosionsschutzVerhindertKaltschweissen;